import styled from 'styled-components'
import { Button, Popup } from 'common-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import {
  MOBILE_SIZE_BREAKPOINT,
  SMALL_DESKTOP_SIZE_BREAKPOINT,
  SMALL_MOBILE_SIZE_BREAKPOINT
} from 'consts'
import {
  normalizeAndConvertAspectRatioForCSS,
  SQUARE_ASPECT_RATIO
} from 'utils/aspectRatio'

export const CustomPopup = styled(Popup)`
  .popup-content {
    border-radius: ${RADII.popup};
    padding: 32px 24px;
  }
`

export const PreviewImagePopupContent = styled.div`
  padding-top: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
`

export const PreviewImageWrapper = styled.div<{ $aspectRatio: string }>`
  position: relative;
  display: block;
  aspect-ratio: ${({ $aspectRatio }) =>
    normalizeAndConvertAspectRatioForCSS($aspectRatio)};
  width: 500px;
  border: 1px solid ${COLORS.border};
  border-radius: ${RADII.card};
  overflow: hidden;
  background-image: repeating-conic-gradient(
    ${COLORS.fillStrong} 0 25%,
    ${COLORS.border} 0 50%
  );
  background-size: 23px 23px;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 400px;
  }

  @media screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    width: 100%;
    height: auto;
    min-height: 150px;
    max-height: 50vh;
  }

  @media screen and (max-width: ${SMALL_MOBILE_SIZE_BREAKPOINT}px) {
    width: 250px;
  }
`

export const PreviewImage = styled.img<{ $aspectRatio: string }>`
  margin: auto;
  width: 100%;
  height: 100%;
  /* we use 'cover' for other aspect ratios because media dimensions may not match
  // the aspect ratio, so we need to fill the container properly. */
  object-fit: ${({ $aspectRatio }) =>
    $aspectRatio === SQUARE_ASPECT_RATIO ? 'contain' : 'cover'};
  border-radius: ${RADII.card};
`

export const SkeletonWrapper = styled.div`
  background-color: ${COLORS.primaryLight};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: ${RADII.card};
  width: 100%;
  height: 100%;
`

export const CustomButton = styled(Button)`
  padding: 12px 20px;
  height: auto;
  font-weight: 600;
`
